"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XorSchema = exports.OrSchema = void 0;
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class OrSchema extends schema_1.Schema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Or);
        this.apply(objectInitializer);
    }
}
exports.OrSchema = OrSchema;
class XorSchema extends schema_1.Schema {
    constructor(name, description, objectInitializer) {
        super(name, description, schema_type_1.SchemaType.Xor);
        this.apply(objectInitializer);
    }
}
exports.XorSchema = XorSchema;
//# sourceMappingURL=relationship.js.map